import { appliesMeta } from '@/utils/functions/applies-meta'
import Dependencies from 'components/dependencies'

export default appliesMeta({
  template: 'chameleon',
  requiresAuth: true
}, [
  {
    path: '/support/project-dependencies',
    component: Dependencies.ApplicationsIndex,
    name: 'support.project-dependencies'
  },
  {
    path: '/support/project-dependencies/:applicationId',
    props: true,
    component: Dependencies.ApplicationsSingle,
    children: [
      {
        path: '/support/project-dependencies/:applicationId',
        name: 'support.project-dependencies.single',
        component: Dependencies.ApplicationsSingleDependencies
      },
      {
        path: 'vulnerabilities',
        name: 'support.project-dependencies.single.vulnerabilities',
        component: Dependencies.ApplicationsSingleVulnerabilities
      }
    ]
  }
])
